import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-13c07cca")
const _hoisted_1 = { id: "top-tool-bar-component" }
const _hoisted_2 = {
  key: 0,
  id: "left-side"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 33 33",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(2.6455,0,0,2.6455,-5841.27,-5632.28)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M2214.24,2129C2210.82,2129 2208,2131.82 2208,2135.24C2208,2138.66 2210.82,2141.47 2214.24,2141.47C2217.66,2141.47 2220.47,2138.66 2220.47,2135.24C2220.47,2131.82 2217.66,2129 2214.24,2129ZM2218.12,2135.91L2212.16,2135.91L2214.59,2138.04C2214.74,2138.16 2214.82,2138.35 2214.82,2138.54C2214.82,2138.71 2214.76,2138.86 2214.65,2138.99C2214.53,2139.14 2214.34,2139.22 2214.14,2139.22C2213.98,2139.22 2213.82,2139.16 2213.7,2139.05L2209.91,2135.74C2209.9,2135.74 2209.9,2135.74 2209.89,2135.73C2209.87,2135.71 2209.86,2135.69 2209.84,2135.67C2209.83,2135.66 2209.81,2135.64 2209.8,2135.63C2209.79,2135.6 2209.77,2135.57 2209.76,2135.55C2209.75,2135.54 2209.74,2135.52 2209.74,2135.51C2209.72,2135.48 2209.72,2135.44 2209.7,2135.41C2209.7,2135.4 2209.69,2135.39 2209.69,2135.38C2209.67,2135.28 2209.67,2135.19 2209.69,2135.1C2209.69,2135.09 2209.7,2135.08 2209.7,2135.07C2209.72,2135.03 2209.72,2135 2209.74,2134.97C2209.74,2134.95 2209.75,2134.94 2209.76,2134.93C2209.77,2134.9 2209.78,2134.87 2209.8,2134.85C2209.81,2134.83 2209.83,2134.82 2209.84,2134.81C2209.86,2134.78 2209.88,2134.76 2209.89,2134.74C2209.9,2134.74 2209.9,2134.73 2209.91,2134.73L2213.7,2131.42C2213.98,2131.18 2214.41,2131.21 2214.65,2131.49C2214.76,2131.61 2214.82,2131.77 2214.82,2131.93C2214.82,2132.13 2214.74,2132.31 2214.59,2132.44L2212.16,2134.56L2218.12,2134.56C2218.49,2134.56 2218.8,2134.87 2218.8,2135.24C2218.8,2135.61 2218.49,2135.92 2218.12,2135.92L2218.12,2135.91Z" })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 8,
  id: "place-holder"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Label Size", -1)
const _hoisted_8 = {
  key: 9,
  id: "place-holder"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Label Type", -1)
const _hoisted_10 = { class: "object-utility" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 33 33",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(2.6455,0,0,2.6455,-5841.27,-5632.28)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M2214.24,2129C2210.82,2129 2208,2131.82 2208,2135.24C2208,2138.66 2210.82,2141.47 2214.24,2141.47C2217.66,2141.47 2220.47,2138.66 2220.47,2135.24C2220.47,2131.82 2217.66,2129 2214.24,2129ZM2218.12,2135.91L2212.16,2135.91L2214.59,2138.04C2214.74,2138.16 2214.82,2138.35 2214.82,2138.54C2214.82,2138.71 2214.76,2138.86 2214.65,2138.99C2214.53,2139.14 2214.34,2139.22 2214.14,2139.22C2213.98,2139.22 2213.82,2139.16 2213.7,2139.05L2209.91,2135.74C2209.9,2135.74 2209.9,2135.74 2209.89,2135.73C2209.87,2135.71 2209.86,2135.69 2209.84,2135.67C2209.83,2135.66 2209.81,2135.64 2209.8,2135.63C2209.79,2135.6 2209.77,2135.57 2209.76,2135.55C2209.75,2135.54 2209.74,2135.52 2209.74,2135.51C2209.72,2135.48 2209.72,2135.44 2209.7,2135.41C2209.7,2135.4 2209.69,2135.39 2209.69,2135.38C2209.67,2135.28 2209.67,2135.19 2209.69,2135.1C2209.69,2135.09 2209.7,2135.08 2209.7,2135.07C2209.72,2135.03 2209.72,2135 2209.74,2134.97C2209.74,2134.95 2209.75,2134.94 2209.76,2134.93C2209.77,2134.9 2209.78,2134.87 2209.8,2134.85C2209.81,2134.83 2209.83,2134.82 2209.84,2134.81C2209.86,2134.78 2209.88,2134.76 2209.89,2134.74C2209.9,2134.74 2209.9,2134.73 2209.91,2134.73L2213.7,2131.42C2213.98,2131.18 2214.41,2131.21 2214.65,2131.49C2214.76,2131.61 2214.82,2131.77 2214.82,2131.93C2214.82,2132.13 2214.74,2132.31 2214.59,2132.44L2212.16,2134.56L2218.12,2134.56C2218.49,2134.56 2218.8,2134.87 2218.8,2135.24C2218.8,2135.61 2218.49,2135.92 2218.12,2135.92L2218.12,2135.91Z" })
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "menu-label" }, "Copy", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "menu-label" }, "Paste", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "menu-label" }, [
  /*#__PURE__*/_createTextVNode("Align"),
  /*#__PURE__*/_createElementVNode("b", { class: "caret" })
], -1)
const _hoisted_18 = {
  id: "drop-body",
  ref: "dropBody"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Left ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Right ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Top ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Bottom ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Center Horizontal ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Center Vertical ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Center Both ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "menu-label" }, "Undo", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "menu-label" }, "Redo", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelShapesButton = _resolveComponent("LabelShapesButton")!
  const _component_CustomLabelSizesButton = _resolveComponent("CustomLabelSizesButton")!
  const _component_LabelSizesButton = _resolveComponent("LabelSizesButton")!
  const _component_LabelMaterialsButton = _resolveComponent("LabelMaterialsButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.clientDimensions.width > 767)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backButton && _ctx.backButton(...args))),
            ref: "navBackBtn",
            class: "nav-back-button"
          }, _hoisted_5, 512),
          (Object.entries(_ctx.labelShapes).length && _ctx.currentLabelType === 'custom-printed')
            ? (_openBlock(), _createBlock(_component_LabelShapesButton, {
                key: 0,
                isDisabled: true
              }))
            : _createCommentVNode("", true),
          (Object.entries(_ctx.customLabelSizes).length && _ctx.currentLabelType === 'custom-printed')
            ? (_openBlock(), _createBlock(_component_CustomLabelSizesButton, {
                key: 1,
                idx: 0,
                isDisabled: false
              }))
            : _createCommentVNode("", true),
          (Object.entries(_ctx.customLabelSizes).length && _ctx.currentLabelType === 'custom-printed')
            ? (_openBlock(), _createBlock(_component_CustomLabelSizesButton, {
                key: 2,
                idx: 1,
                isDisabled: false
              }))
            : _createCommentVNode("", true),
          (Object.entries(_ctx.labelShapes).length && _ctx.currentLabelType === 'custom-rollprinted')
            ? (_openBlock(), _createBlock(_component_LabelShapesButton, {
                key: 3,
                isDisabled: true
              }))
            : _createCommentVNode("", true),
          (Object.entries(_ctx.customLabelSizes).length && _ctx.currentLabelType === 'custom-rollprinted')
            ? (_openBlock(), _createBlock(_component_CustomLabelSizesButton, {
                key: 4,
                idx: 0,
                isDisabled: true
              }))
            : _createCommentVNode("", true),
          (
          Object.entries(_ctx.customLabelSizes).length &&
            _ctx.currentLabelType === 'custom-rollprinted' &&
            _ctx.currentLabel.shape_id !== 10 &&
            _ctx.currentLabel.shape_id !== 3
        )
            ? (_openBlock(), _createBlock(_component_CustomLabelSizesButton, {
                key: 5,
                idx: 1,
                isDisabled: true
              }))
            : _createCommentVNode("", true),
          (
          Object.entries(_ctx.labelShapes).length &&
            (_ctx.currentLabelType === 'printed' || _ctx.currentLabelType === 'rollprinted')
        )
            ? (_openBlock(), _createBlock(_component_LabelShapesButton, {
                key: 6,
                isDisabled: false
              }))
            : _createCommentVNode("", true),
          (
          Object.entries(_ctx.labelSizes).length &&
            (_ctx.currentLabelType === 'printed' || _ctx.currentLabelType === 'rollprinted')
        )
            ? (_openBlock(), _createBlock(_component_LabelSizesButton, { key: 7 }))
            : _createCommentVNode("", true),
          (_ctx.currentLabelType === 'flyer' || _ctx.currentLabelType === 'magnet')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_ctx.currentLabel.width) + "    x    " + _toDisplayString(_ctx.currentLabel.height), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentLabelType === 'flyer' || _ctx.currentLabelType === 'magnet')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(_ctx.currentLabelType
              .split("-")
              .map(
                (section) =>
                  `${section.slice(0, 1).toUpperCase()}${section.slice(1, section.length)}`
              )
              .join(" ")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentLabelType !== 'flyer' && _ctx.currentLabelType !== 'magnet')
            ? (_openBlock(), _createBlock(_component_LabelMaterialsButton, { key: 10 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.clientDimensions.width < 767)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.backUrl,
            ref: "navBackBtn",
            class: "nav-back-button"
          }, _hoisted_14, 8, _hoisted_11))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "btn-copy",
        class: _normalizeClass(_ctx.currentActiveObject ? 'active-object' : 'inactive-object'),
        style: _normalizeStyle(_ctx.isCopied ? 'color: white; background-color: black;' : ''),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCopy && _ctx.handleCopy(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: "font-awesome",
          icon: "copy",
          "aria-hidden": "true"
        }),
        _hoisted_15
      ], 6),
      _createElementVNode("div", {
        id: "btn-paste",
        class: _normalizeClass(_ctx.currentActiveObject ? 'active-object' : 'inactive-object'),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: "font-awesome",
          icon: "paste",
          "aria-hidden": "true"
        }),
        _hoisted_16
      ], 2),
      _createElementVNode("div", {
        id: "align-drop-down",
        ref: "dropContainer",
        class: _normalizeClass(_ctx.currentActiveObject ? 'active-object' : 'inactive-object'),
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDropDown && _ctx.handleDropDown(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: "font-awesome",
          icon: "align-left",
          "aria-hidden": "true"
        }),
        _hoisted_17,
        (_ctx.showDropDown && _ctx.currentActiveObject)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 0,
              to: "#editor-window"
            }, [
              _createElementVNode("ul", _hoisted_18, [
                _createElementVNode("li", null, [
                  _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.alignObject('left')))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "font-awesome",
                      icon: "align-left",
                      "aria-hidden": "true"
                    }),
                    _hoisted_19
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.alignObject('right')))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "font-awesome",
                      icon: "align-right",
                      "aria-hidden": "true"
                    }),
                    _hoisted_20
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.alignObject('top')))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "font-awesome",
                      icon: "arrow-up",
                      "aria-hidden": "true"
                    }),
                    _hoisted_21
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.alignObject('bottom')))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "font-awesome",
                      icon: "arrow-down",
                      "aria-hidden": "true"
                    }),
                    _hoisted_22
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.alignObject('centerHorizontal')))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "font-awesome",
                      icon: "align-center",
                      "aria-hidden": "true"
                    }),
                    _hoisted_23
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.alignObject('centerVertical')))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "font-awesome",
                      icon: "align-center",
                      "aria-hidden": "true"
                    }),
                    _hoisted_24
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.alignObject('centerBoth')))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "font-awesome",
                      icon: "bars",
                      "aria-hidden": "true"
                    }),
                    _hoisted_25
                  ])
                ])
              ], 512)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        id: "undo-btn",
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleUndo && _ctx.handleUndo(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: "font-awesome",
          icon: "undo",
          "aria-hidden": "true"
        }),
        _hoisted_26
      ]),
      _createElementVNode("div", {
        id: "redo-btn",
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleRedo && _ctx.handleRedo(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: "font-awesome",
          icon: "redo",
          "aria-hidden": "true"
        }),
        _hoisted_27
      ])
    ])
  ]))
}